<!--其它出库  -->
<template>
	<div class="info-box">
		<el-dialog
			title="生动化检查信息"
			v-if="dialogVisible"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:modal-append-to-body="false"
			width="1000px"
			:before-close="cancle"
			top="3vh">
			<div>
				<div class="info-title">基本信息:</div>
				<!--  -->
				<div class="mt5">
					<div class="flex nc-box">
						<div class="flex-1">
							<span class="info-name">单号:</span>
							<span class="ml15">{{ rowData.orderNo || "无" }}</span>
						</div>
						<div class="flex-1">
							<span class="info-name">客商:</span>
							<span class="ml15">{{ rowData.agentName || "无" }}</span>
						</div>
					</div>
					<div class="flex nc-box">
						<div class="flex-1">
							<span class="info-name">计划日期:</span>
							<span class="ml15">{{ rowData.planDate || "无" }}</span>
						</div>
						<div class="flex-1">
							<span class="info-name">路线:</span>
							<span class="ml15">{{ rowData.routeName || "无" }}</span>
						</div>
					</div>
					<!--  -->
					<!--  -->
					<div class="flex nc-box">
						<div class="flex-1">
							<span class="info-name">巡回计划:</span>
							<span class="ml15">{{ rowData.planCode || "无" }}</span>
						</div>
						<div class="flex-1">
							<span class="info-name">主路线员:</span>
							<span class="ml15">{{ rowData.mainUserName || "无" }}</span>
						</div>
					</div>
					<!--  -->
					<!--  -->
					<div class="flex nc-box">
						<div class="flex-1">
							<span class="info-name">副路线员:</span>
							<span class="ml15">{{ rowData.secUserName || "无" }}</span>
						</div>
						<div class="flex-1">
							<span class="info-name">价签:</span>
							<span class="ml15">{{ rowData.priceTag || "无" }}</span>
						</div>
					</div>
					<!--  -->
					<!--  -->
					<div class="flex nc-box">
						<div class="flex-1">
							<span class="info-name">跳卡:</span>
							<span class="ml15">{{ rowData.skipCard || "无" }}</span>
						</div>
						<div class="flex-1">
							<span class="info-name">海报:</span>
							<span class="ml15">{{ rowData.poster || "无" }}</span>
						</div>
					</div>
					<!--  -->
					<!--  -->
					<div class="flex nc-box">
						<div class="flex-1">
							<span class="info-name">礼盒:</span>
							<span class="ml15">{{ rowData.giftBox || "无" }}</span>
						</div>
						<div class="flex-1">
							<span class="info-name">冰箱:</span>
							<span class="ml15">{{ rowData.bingXiang || "无" }}</span>
						</div>
					</div>
					<!--  -->
					<!--  -->
					<div class="flex nc-box">
						<div class="flex-1">
							<span class="info-name">冰台:</span>
							<span class="ml15">{{ rowData.bingTai || "无" }}</span>
						</div>
						<div class="flex-1"></div>
					</div>
					<!--  -->
					<!--  -->
				</div>
			</div>
			<!-- 配送客商情况 -->
			<div class="info-title mt20">检查明细:</div>
			<div class="peng-box">
				<div class="flex-1">
					<div>检查类型</div>
					<div v-for="(item, i) in pengPaiList" :key="i">
						{{ ["1091", "1092"].includes(item.checkItemSid) ? `${item.skuName}${item.checkItemName}` : `${item.checkItemName}` }}
					</div>
				</div>
				<div class="flex-1">
					<div>描述</div>
					<div v-for="(item, i) in pengPaiList" :key="i">
						{{ item.checkResult }}
					</div>
				</div>
			</div>
			<!-- 陈列方向 -->
			<div class="list-box">
				<p class="list-title">陈列方向</p>
				<div class="list-content">
					<el-checkbox v-model="item.checkResult" true-label="Y" false-label="N" v-for="(item, i) in displayDirectList" :key="`a${i}`" disabled>
						{{ item.checkItemName }}
					</el-checkbox>
					{{ displayDirectList.length === 0 ? "暂无数据" : "" }}
				</div>
			</div>
			<!-- 电商信息 -->
			<div class="list-box">
				<p class="list-title">电商信息</p>
				<div class="list-content">
					<el-checkbox v-model="item.checkResult" true-label="Y" false-label="N" v-for="(item, i) in eplatfromList" :key="`b${i}`" disabled>
						{{ item.checkItemName }}
					</el-checkbox>
					{{ eplatfromList.length === 0 ? "暂无数据" : "" }}
				</div>
			</div>
			<!-- 线上销售SKU -->
			<div class="list-box">
				<p class="list-title">线上销售SKU</p>
				<div class="list-content">
					<el-checkbox v-model="item.checkResult" true-label="Y" false-label="N" v-for="(item, i) in onlineSkuList" :key="`c${i}`" disabled>
						{{ item.checkItemName }}
					</el-checkbox>
					{{ onlineSkuList.length === 0 ? "暂无数据" : "" }}
				</div>
			</div>
			<!-- 店铺装饰 -->
			<div class="list-box">
				<p class="list-title">店铺装饰</p>
				<div class="list-content">
					<el-checkbox v-model="item.checkResult" true-label="Y" false-label="N" v-for="(item, i) in storeDecorationList" :key="`d${i}`" disabled>
						{{ item.checkItemName }}
					</el-checkbox>
					{{ storeDecorationList.length === 0 ? "暂无数据" : "" }}
				</div>
			</div>
			<!-- 排面照片 -->
			<div class="info-title mt20">排面照片:</div>
			<ul class="ul-img">
				<li v-for="(item, i) in photos" :key="i + 'li'" @click="viewerHandle(photos, i)">
					<img :key="i + 'img'" :src="item.photoUrl" alt="" />
				</li>
			</ul>
			<!-- ISM照片 -->
			<div class="info-title mt20">ISM照片:</div>
			<ul class="ul-img">
				<li v-for="(item, i) in ismPhotos" :key="i + 'ism'" @click="viewerHandle(ismPhotos, i)">
					<img :key="i + 'img'" :src="item.photoUrl" alt="" />
				</li>
			</ul>

			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="cancle()">取 消</el-button>
			</span>
		</el-dialog>
		<!-- 照片预览 -->
		<viewer ref="viewer" v-if="viewFlag" @closeViewer="closeViewer"></viewer>
	</div>
</template>

<script>
import { dateTimeFormat } from "@/utils/common";
import viewer from "@/components/viewer";
export default {
	components: {
		viewer,
	},
	data() {
		return {
			dialogVisible: false,
			dateTimeFormat: null,
			ruleForm: {
				checkId: "",
			},
			rowData: {},
			checkList: [],
			inventoryList: [],
			// 棚段排面列表
			pengPaiList: [],
			// 陈列方向列表
			displayDirectList: [],
			// 电商信息列表
			eplatfromList: [],
			// 线上销售SKU列表
			onlineSkuList: [],
			// 店铺装饰列表
			pengPaiList: [],
			// 排面照片列表
			storeDecorationList: [],
			photos: [],
			// ism照片列表
			ismPhotos: [],
			// 图片预览弹窗控件
			viewFlag: false,
		};
	},
	created() {
		this.dateTimeFormat = dateTimeFormat;
	},
	methods: {
		init(data) {
			this.$nextTick(() => {
				this.dialogVisible = true;
				this.rowData = {};
				this.pageNo = 1;
				this.ruleForm = {
					checkId: "",
				};
				if (data) {
					this.ruleForm.checkId = data.dataKey;
					this.getInfo();
				}
			});
		},
		// 查询
		getInfo() {
			let self = this;
			self.$request
				.post("storeCheckInfo", true, {
					checkId: self.ruleForm.checkId,
				})
				.then((res) => {
					if (res) {
						self.checkList = res.data.checkList;
						self.rowData = res.data;
						// 排面照片列表
						self.photos = res.data.photos == null ? [] : res.data.photos;
						// ismPhotos列表
						self.ismPhotos = res.data.ismPhotos == null ? [] : res.data.ismPhotos;
						// 棚段排面列表
						self.pengPaiList = res.data.pengPaiList ? res.data.pengPaiList : [];
						// 陈列方向列表
						self.displayDirectList = res.data.displayDirectList ? res.data.displayDirectList : [];
						// 电商信息列表
						self.eplatfromList = res.data.eplatfromList ? res.data.eplatfromList : [];
						// 线上销售SKU列表
						self.onlineSkuList = res.data.onlineSkuList ? res.data.onlineSkuList : [];
						// 店铺装饰列表
						self.storeDecorationList = res.data.storeDecorationList ? res.data.storeDecorationList : [];
					}
				});
		},
		// 图片预览
		viewerHandle(photos, index) {
			this.viewFlag = true;
			this.$nextTick(() => {
				let imageList = [];
				for (const iterator of photos) {
					imageList.push(iterator.photoUrl);
				}
				this.$refs.viewer.init(index, imageList);
			});
		},
		// 关闭图片预览弹窗
		closeViewer() {
			this.viewFlag = false;
		},
		// 取消
		cancle() {
			this.dialogVisible = false;
			this.$emit("getList");
		},
	},
	beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.mb0 {
	margin-bottom: 0 !important;
}

.w90 {
	width: 110px;
}

.nc-box {
	padding: 10px;
	border-bottom: 1px solid #dcdfe6;
	color: #606266;
	font-size: 13px;
}

.mb10 {
	margin-bottom: 10px !important;
}

.w190 {
	width: 280px !important;
}

.info-box {
	/deep/ .el-dialog__body {
		// height: 330px;
		padding: 20px 20px 10px;
		overflow-y: auto;
	}
}

.info-title {
	background: #e5e5e5;
	color: #333;
	padding: 10px;
	box-sizing: border-box;
	font-size: 16px;
	font-weight: bold;

	img {
		vertical-align: bottom;
		display: block;
	}
}

.el-form-item {
	width: 420px;
}

.w330 {
	width: 330px;
}

.w420 {
	width: 420px !important;
	margin-right: 10px;
}

.info-name {
	display: inline-block;
	width: 140px;
	text-align: right;
}

.opeartion {
	font-size: 18px;
}

.lh30 {
	line-height: 30px;
}

.el-table {
	// 深度选择器，去除默认的padding
	/deep/ th {
		padding: 5px;
	}

	/deep/ td {
		padding: 5px;
	}
}

.nc-box {
	padding: 10px;
	border-bottom: 1px solid #dcdfe6;
	color: #606266;
	font-size: 13px;
}
.info-name {
	display: inline-block;
	width: 140px;
	text-align: right;
	color: #999;
}

.ul-img {
	margin: 4px 10px 2px;
	li {
		list-style: none;
		display: inline-block;
		img {
			margin-right: 10px;
			width: 110px;
			height: 110px;
		}
	}
}

.list-box {
	margin-top: 10px;
	box-sizing: border-box;
	padding: 0 10px;
}

.list-title {
	background: rgba(200, 204, 215, 0.6);
	color: #333;
	padding: 5px 20px;
	box-sizing: border-box;
	font-size: 16px;
	font-weight: bold;
}

.list-content {
	border: 1px solid #ebeef5;
	border-top: none;
	padding: 10px 20px;
}

.list-content ::v-deep .el-checkbox__input.is-disabled + span.el-checkbox__label {
	color: #606266;
}

.peng-box {
	display: flex;
	margin-top: 5px;
	box-sizing: border-box;
	padding: 0 10px;
	.flex-1 {
		flex: 1;
		div {
			line-height: 34px;
			height: 34px;
			border-top: 1px solid #ebeef5;
			border-left: 1px solid #ebeef5;
			padding: 0 10px;
			&:first-child {
				background: rgba(200, 204, 215, 0.6);
				color: #333;
				font-size: 16px;
				font-weight: bold;
			}
			&:last-child {
				border-bottom: 1px solid #ebeef5;
			}
		}
		&:last-child {
			border-right: 1px solid #ebeef5;
		}
	}
	div {
		color: #606266;
	}
}

.list-box ::v-deep .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
	background-color: #409eff;
	border-color: #409eff;
}

.list-box ::v-deep .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
	border-color: #fff;
}
</style>
